import ErrorHandler from "@/services/ErrorService/ErrorService";
import { STRIPE_CHECKOUT_DOMAIN } from "@/shared/constants/common";
import type {
	BillingAddress,
	FormType,
	StripeCheckoutRequestData,
	SubscriptionPeriod,
	SubscriptionPlan,
} from "../../types";

type Args = {
	address: BillingAddress;
	selectedPlan: SubscriptionPlan | null;
	period: SubscriptionPeriod;
	referralId?: string;
	couponId?: string;
	getCheckoutUrl: (
		options: StripeCheckoutRequestData,
	) => Promise<string | null>;
	setOpenModal: (modal: FormType | null) => void;
};

export async function stripeCheckout(args: Args) {
	const {
		address,
		selectedPlan,
		period,
		referralId,
		couponId,
		getCheckoutUrl,
		setOpenModal,
	} = args;

	if (!selectedPlan) return;

	const checkoutUrl = await getCheckoutUrl({
		plan: selectedPlan,
		period,
		success_url: `${window.location.origin}/dashboard?redirect=stripe`,
		billing_address: address,
		...(referralId && { referral_id: referralId }),
		...(couponId && { coupon: couponId }),
	});

	if (checkoutUrl && checkoutUrl.trim().length > 0) {
		try {
			const url = new URL(checkoutUrl);

			if (!STRIPE_CHECKOUT_DOMAIN.includes(url.hostname)) {
				throw new Error("Untrusted checkout domain");
			}

			setOpenModal(null);
			window.location.assign(checkoutUrl);
		} catch (_e) {
			ErrorHandler.logError(new Error("Invalid checkout URL format"));
		}
	} else {
		ErrorHandler.logError(new Error("Checkout URL is empty"));
	}
}

export type StripeCheckoutFn = typeof stripeCheckout;
